<template>
    <div>
        <v-app-bar app class="elevation-0" color="white" id="appbar">
            <v-app-bar-nav-icon @click.stop="setDrawer(!drawer)"></v-app-bar-nav-icon>

            <v-spacer></v-spacer>

            <template v-if="!isMobile()">
                <v-menu
                    v-model="helpMenu"
                    :close-on-content-click="false"
                    offset-y
                    transition="slide-y-transition"
                    left
                >
                    <template v-slot:activator="{ on, attrs }">
                        <v-btn
                            color="gray"
                            dark
                            v-bind="attrs"
                            v-on="on"
                            icon
                            depressed
                        >
                            <v-icon>mdi-help-circle-outline</v-icon>
                        </v-btn>
                    </template>

                    <v-card max-width="300">
                        <v-card-title class="text-h5 font-weight-bold">{{ $t('helpDesk') }}</v-card-title> 

                        <!-- <v-divider></v-divider> -->

                        <v-card-text>
                            <v-row>
                                <v-col cols="6">
                                    <v-card
                                        class="text-center"
                                        @click="helpDeskClicked('faq')"
                                    >
                                        <v-card-text>
                                            <v-img
                                                lazy-src="/icons/faq.png"
                                                max-height="35"
                                                max-width="35"
                                                src="/icons/faq.png"
                                                style="margin: auto;"
                                            ></v-img>
                                            <h4 class="black--text">{{ $t('faqs') }}</h4>
                                        </v-card-text>
                                    </v-card>
                                </v-col>
                                <v-col cols="6">
                                    <v-card
                                        class="text-center"
                                        @click="helpDeskClicked('task')"
                                    >
                                        <v-card-text>
                                            <v-img
                                                lazy-src="/icons/tasks.png"
                                                max-height="35"
                                                max-width="35"
                                                src="/icons/tasks.png"
                                                style="margin: auto;"
                                            ></v-img>
                                            <h4 class="black--text">{{ $t("Enquiries") }}</h4>
                                        </v-card-text>
                                    </v-card>
                                </v-col>
                                <v-col cols="12">
                                    <v-card
                                        class="text-center"
                                        @click="helpDeskClicked('phone')"
                                    >
                                        <v-card-text>
                                            <v-img
                                                lazy-src="/icons/phone.png"
                                                max-height="35"
                                                max-width="35"
                                                src="/icons/phone.png"
                                                style="margin: auto;"
                                            ></v-img>
                                            <h4 class="black--text">{{ $t('contactUs') }}</h4>
                                        </v-card-text>
                                    </v-card>
                                </v-col>
                            </v-row>
                        </v-card-text>
                    </v-card>
                </v-menu>
                <v-menu offset-y>
                    <template v-slot:activator="{ on, attrs }">
                        <v-list color="transparent">
                            <v-list-item two-line >
                                <v-list-item-avatar>
                                    <img :lazy-src="imgURL" :src="imgURL">
                                </v-list-item-avatar>

                                <v-list-item-content class="d-block">
                                    <v-list-item-title>{{ currentUser.firstName }}</v-list-item-title>
                                    <v-list-item-subtitle>{{ currentUser.email }}</v-list-item-subtitle>
                                </v-list-item-content>
                                <v-list-item-action>
                                    <v-btn icon dark v-bind="attrs" v-on="on">
                                        <v-icon class="gray--text">mdi-chevron-down</v-icon>
                                    </v-btn>
                                </v-list-item-action>
                            </v-list-item>
                        </v-list>
                        </template>
                        <v-list>
                            <v-list-item @click="$router.replace({name: 'profile'});">{{ $t('profile') }}</v-list-item>
                            <v-divider></v-divider>
                            <v-list-item @click="logout">
                                {{ $t('logout') }}
                            </v-list-item>
                        </v-list>
                    </v-menu>
            </template>
            <template v-else></template>
            <div class="pt-5">
                <LanguageSelection :pageReload="true"/>
            </div>
        </v-app-bar>
        <ContactUs :dialogU="showContactUs" @closeContactUs="closeContactUs"/>
    </div>
</template>

<script>
import { mapState } from "vuex"
import isMobileMixin from "@/mixins/isMobileMixin"
import LoadingMixin from "@/mixins/LoadingMixin"
import ProfileService from "@/_services/ProfileService";

import ContactUs from "@/components/ContactUs.vue"

export default {
    components: {
        ContactUs
    },
    computed: {
        ...mapState(['drawer']),
        currentUser() {
            return this.$store.getters.getUser
        }
    },
    created() {
        this.getProfileData();
    },
    data(){
        return{
            imgURL: '/img/user.jpg',
            helpMenu: false,
            showContactUs: false,
        }
    },
    methods: {
        helpDeskClicked(type){
            this.helpMenu = false;
            if(type == 'faq') {
                this.$router.push({ name: 'Faq'});
            }else if(type == 'task') {
                this.$router.push({ name: 'Enquiries'});
            }else{
                this.showContactUs=true;
            }
        },
        closeContactUs() {
            this.showContactUs = false;
        },
        setDrawer(val) {
            this.$store.commit('SET_DRAWER', val)
        },
        async logout() {
            this.startLoading();
            await this.$store.dispatch('logout');
            this.stopLoading();
            this.$router.replace({name: 'login'});
        },
        getProfileData() {
            ProfileService.getProfileData()
            .then((res) => {
                if (res.success && res.data.profilePicUrl != '' && res.data.profilePicUrl != null) {
                    this.imgURL = res.data.profilePicUrl;
                }
            })
            .catch((e) => {
                console.log(e);
            });
        },
    },
    mixins: [isMobileMixin, LoadingMixin]
}
</script>

<style scoped>

</style>